module.exports = __webpack_public_path__ + "img/bus-front.488838b.svg";